<template>
    <legal-layout>
    <v-layout>
        <v-container w--max--800>
            <v-layout column>
                <v-flex>
                    <app-name-page name="Terms of use"></app-name-page>
                </v-flex>
                <v-flex>
                    <v-card flat>
                        <v-card-text v-html="item.description"
                                     class="app-html-text"></v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-layout>
    </legal-layout>
</template>

<script>
  import AppNamePage from '../../../components/app-name-page'
  import LegalLayout from './legal-layout'
  export default {
    name: 'legal',
    components: {AppNamePage, LegalLayout},
//     mounted () {
//     document.title = "Your Peace of Mind Matters – NannyGranny Legal Info & Policies"
//     const updateMetaTag = (name, content) => {
//         let metaTag = document.querySelector(`meta[name="${name}"]`)
//         if (metaTag) {
//             metaTag.setAttribute('content', content)
//         } else {
//             metaTag = document.createElement('meta')
//             metaTag.setAttribute('name', name)
//             metaTag.setAttribute('content', content)
//             document.head.appendChild(metaTag)
//         }
//     }
//     updateMetaTag('description', "Find professional, caring, and experienced nannies to support your family's needs. Our trusted childcare services ensure the best care and safety for children.")
//     updateMetaTag('title', 'Your Peace of Mind Matters – NannyGranny Legal Info & Policies')
// },

metaInfo() {
    return {
      title: 'Your Peace of Mind Matters – NannyGranny Legal Info & Policies',
      meta: [
        {
          name: 'description',
          content: 'Find professional, caring, and experienced nannies to support your family\'s needs. Our trusted childcare services ensure the best care and safety for children.'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: window.location.href
        }
      ]
    }
  },
    computed: {
      item () {
        return this.$store.getters['page/content']('legal')[0]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/content/legal/index.vue